export function canAddToCart(item?: {
  can_add_to_cart?: boolean;
  in_stock?: boolean;
} | null): boolean {
  if (!item) return true;
  if (item.can_add_to_cart === false) return false;
  if (item.in_stock === false) return false;
  return true;
}

export function stockStatusLabel(item?: {
  stock_status_label?: string;
} | null): string {
  return item?.stock_status_label ? String(item.stock_status_label) : "";
}
